// extracted by mini-css-extract-plugin
export default {"slick":"Slick_slick__lN9um"};